__turbopack_context__.v({
  "boundUnit": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__boundUnit",
  "fieldError": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__fieldError",
  "section": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__section",
  "sectionDisabled": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__sectionDisabled",
  "slider": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__slider",
  "sliderBlock": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__sliderBlock",
  "sliderBounds": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__sliderBounds",
  "sliderWrap": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__sliderWrap",
  "value": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__value",
  "valueLabel": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__valueLabel",
  "valueRow": "QuoteFormLcvCapacitySlider-module-scss-module__cqKMdG__valueRow",
});
